import {Icon} from '@ezcater/tapas';
import {faStore} from '@fortawesome/pro-regular-svg-icons';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import {twMerge} from 'tailwind-merge';

import {type EventBarDraftOrder} from '../hooks/useEventBarDraftOrders';

type WhatDraftOrderOptionProps = {
  draftOrder: EventBarDraftOrder;
  id: string;
  isActive?: boolean;
  onSelect: () => void;
};

const WhatDraftOrderOption: React.FC<WhatDraftOrderOptionProps> = ({
  draftOrder,
  id,
  isActive = false,
  onSelect,
}) => {
  const {t} = useTranslation('app-bar');
  const {catererName, dateLabel, timeLabel, headcount, imageUrl, locationLabel} = draftOrder;

  const subtitle = [
    locationLabel,
    dateLabel,
    timeLabel,
    headcount != null ? t('eventBarV2.what.guests', {count: headcount}) : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <button
      aria-selected={isActive}
      className={twMerge(
        'flex w-full cursor-pointer items-center gap-4 rounded-lg px-2 py-2 text-left hover:bg-peppercorn-50',
        isActive && 'bg-peppercorn-50',
      )}
      data-testid="what-draft-order-option"
      id={id}
      onClick={onSelect}
      onMouseDown={event => event.preventDefault()}
      role="option"
      tabIndex={-1}
      type="button"
    >
      {imageUrl ? (
        <Image
          alt=""
          className="h-11 w-11 shrink-0 rounded-lg object-cover"
          data-chromatic="ignore"
          height={44}
          src={imageUrl}
          width={44}
        />
      ) : (
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-peppercorn-50 text-peppercorn-600">
          <Icon aria-hidden icon={faStore} />
        </span>
      )}
      <span className="min-w-0 overflow-hidden">
        <span className="flex items-center gap-1">
          <span className="truncate font-semibold text-peppercorn-800">
            {catererName}
            {subtitle ? ' · ' : ''}
          </span>
          <span className="shrink-0 text-peppercorn-500">
            {t('eventBarV2.what.draftOrderLabel')}
          </span>
        </span>
        {subtitle && <span className="block truncate text-sm text-peppercorn-800">{subtitle}</span>}
      </span>
    </button>
  );
};

export default WhatDraftOrderOption;
